export const CACHE = 'CACHE'
export const CALLS = 'CALLS'
export const SET_SETTINGS = 'SET_SETTINGS'
export const SET_INSTANCE = 'SET_INSTANCE'
export const SET_APPS = 'SET_APPS'
export const SET_NAV_STATE = 'SET_NAV_STATE'
export const ADD_ALERT = 'ADD_ALERT'
export const SET_CURRENT_USER = 'SET_CURRENT_USER'
